import { Signal } from "signals";
import FlexiSlider from "slotworks/graphics/elements/flexi-slider";
import { SliderEvent } from "slotworks/graphics/elements/flexi-slider";
import FlexiText from "slotworks/graphics/elements/flexi-text";

export default class SliderComponent {

    public onChange: Signal;

    public formatFunction: (value: number) => string;

    private slider: FlexiSlider;
    private label: FlexiText;

    private minLabel: FlexiText;
    private maxLabel: FlexiText;

    constructor(slider: FlexiSlider, label: FlexiText, minLabel?: FlexiText, maxLabel?: FlexiText) {
        this.slider = slider;
        this.label = label;

        this.minLabel = minLabel;
        this.maxLabel = maxLabel;

        this.onChange = new Signal();

        this.slider.setEnabled(true);

        this.slider.on(SliderEvent.INPUT, this.inputHandler);
        this.slider.on(SliderEvent.CHANGE, this.changeHandler);
    }

    public setMin(value: number) {
        if (this.minLabel) {
            this.minLabel.setText(this.format(value));
        }

        this.slider.setMin(value);
    }

    public setMax(value: number) {
        if (this.maxLabel) {
            this.maxLabel.setText(this.format(value));
        }

        this.slider.setMax(value);
    }

    public setValue(value: number) {
        this.slider.setValue(value);
        this.updateLabel();
    }

    private inputHandler = () => {
        this.updateLabel();
    }

    private changeHandler = () => {
        this.updateLabel();
        this.onChange.dispatch(this.slider.getValue());
    }

    private updateLabel() {
        const value = this.slider.getValue();
        const text = this.format(value);

        this.label.setText(text);
    }

    private format(value: number): string {
        if (this.formatFunction) {
            return this.formatFunction(value);
        } else {
            return value.toString();
        }
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/ui/slider-component.ts